import React from "react";
import { VStack } from "@chakra-ui/react";
import { ResponsiveRadialBar } from "@nivo/radial-bar";
import { useSearchParams } from "react-router-dom";
import SearchString from "search-string";
import { H2Dashboard } from "components/text/headings";
import { gotoFilteredQuestionList } from "../AIDashboard/AIDashboard";
import { useNavigate } from "react-router-dom";
import { nivo_theme } from "../chart-utils";

const PieByGroup = ({ groupData }) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const handleClick = (questionGroup, stage) => {
    const searchString = SearchString.parse("");
    searchString.addEntry("questionGroup", questionGroup);
    searchString.addEntry("stage", stage);
    const newParams = new URLSearchParams(searchParams);
    newParams.set("q", searchString.toString());
    gotoFilteredQuestionList(navigate, null, null, newParams);
  };

  return (
    <VStack
      spacing={4}
      // bg="gray.200"
      // borderRadius="lg"
      // boxShadow="lg"
      // borderColor="gray.200"
      w="100%"
      h="350px" /* Ensure a fixed height */
      p={6}
      display="flex"
      flexDirection="column"
      color="darkTeal"
    >
      <H2Dashboard>Stage by group</H2Dashboard>

      <ResponsiveRadialBar
        data={groupData}
        innerRadius={0.3}
        padding={0.3}
        cornerRadius={2}
        borderColor={{
          from: "color",
          modifiers: [["darker", "1"]],
        }}
        colors={(d) => d.data.color}
        enableRadialGrid={false}
        enableCircularGrid={false}
        radialAxisStart={{ tickSize: 5, tickPadding: 5, tickRotation: 0 }}
        circularAxisOuter={null}
        legends={[]}
        onClick={(data) => handleClick(data?.groupId, data?.category)}
        theme={nivo_theme}
      />
    </VStack>
  );
};

export default PieByGroup;
